export const providerConfig = {
    official: {
        label: 'Website',
        imgSrc: '/images/website.svg',
        alt: 'website logo',
    },
    facebook: {
        label: 'Facebook',
        imgSrc: '/images/facebook.svg',
        alt: 'facebook logo',
    },
    imdb: {
        label: 'IMDb',
        imgSrc: '/images/imdb.svg',
        alt: 'imdb logo',
    },
    instagram: {
        label: 'Instagram',
        imgSrc: '/images/instagram.svg',
        alt: 'imdb logo',
    },
    spotify: {
        label: 'Spotify',
        imgSrc: '/images/spotify.svg',
        alt: 'spotify logo',
    },
    ted: {
        label: 'TED',
        imgSrc: '/images/ted.svg',
        alt: 'ted logo',
    },
    twitter: {
        label: 'Twitter',
        imgSrc: '/images/twitter.svg',
        alt: 'imdb logo',
    },
    wiki: {
        label: 'Wikipedia',
        imgSrc: '/images/wiki.svg',
        alt: 'wikipedia logo',
    },
    youtube: {
        label: 'youTube',
        imgSrc: '/images/youtube.svg',
        alt: 'youtube logo',
    },
};
